let ctx: AudioContext | null = null;

function getCtx(): AudioContext | null {
  if (!ctx) {
    try {
      // Safari <14.1 only exposes the prefixed constructor.
      const Ctor =
        window.AudioContext ??
        (window as Window & { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
      if (!Ctor) return null;
      ctx = new Ctor();
    } catch {
      return null;
    }
  }
  return ctx;
}

export function playTick(speed = 1) {
  const ac = getCtx();
  if (!ac) return;
  const osc = ac.createOscillator();
  const gain = ac.createGain();
  osc.connect(gain);
  gain.connect(ac.destination);
  const freq = Math.min(800 + speed * 200, 1600);
  osc.frequency.setValueAtTime(freq, ac.currentTime);
  osc.type = 'square';
  gain.gain.setValueAtTime(0.08, ac.currentTime);
  gain.gain.exponentialRampToValueAtTime(0.001, ac.currentTime + 0.04);
  osc.start(ac.currentTime);
  osc.stop(ac.currentTime + 0.04);
}

export function playWin() {
  const ac = getCtx();
  if (!ac) return;
  const notes = [523.25, 659.25, 783.99, 1046.5];
  notes.forEach((freq, i) => {
    const osc = ac.createOscillator();
    const gain = ac.createGain();
    osc.connect(gain);
    gain.connect(ac.destination);
    osc.type = 'sine';
    osc.frequency.setValueAtTime(freq, ac.currentTime + i * 0.13);
    gain.gain.setValueAtTime(0, ac.currentTime + i * 0.13);
    gain.gain.linearRampToValueAtTime(0.22, ac.currentTime + i * 0.13 + 0.04);
    gain.gain.exponentialRampToValueAtTime(0.001, ac.currentTime + i * 0.13 + 0.4);
    osc.start(ac.currentTime + i * 0.13);
    osc.stop(ac.currentTime + i * 0.13 + 0.45);
  });
}

export function resumeAudio() {
  getCtx()?.resume();
}
